module.exports = __webpack_public_path__ + "static/media/39.8f42464d.mp3";